import React, { useEffect } from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import { Box } from '@material-ui/core'
import { QRCodeGenerated } from '../components/QRCodeGenerated'
import { useDispatch } from 'react-redux'
import { resetApp } from '../features/reset/resetAppSlice'
import { useNavigate } from 'react-router-dom'
import { AppRoutes } from '../app/routers'
import { useSelector } from 'react-redux'
import { selectVmDataExperience } from '../features/vmdataSelectors'
import { createHash, createShortUrl } from '../features/qrCode/qrCodeSlice'
import {
  selectIsLoadingHash,
  selectVmUrl,
  selectShortUrl,
  selectQrCodetUrl,
  selectHash,
} from '../features/qrCodeSelectors'
import { Experience } from '../types/expType'

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  })
)

export const EditConfirmationPage: React.FC = () => {
  const styles = useStyles()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const isLoadingHash = useSelector(selectIsLoadingHash)
  const vmUrl = useSelector(selectVmUrl)
  const vmDataExperience = useSelector(selectVmDataExperience)

  const shortUrl = useSelector(selectShortUrl)
  const qrCodeUrl = useSelector(selectQrCodetUrl)

  const expType = useSelector((s) => s.vmData.expType)
  const tokenKey = useSelector(selectHash)
  const isDigitalWindow =
    useSelector((s) => s.vmData.expType) === Experience.DigitalWindow

  const isValidVmDataExperience =
    vmDataExperience &&
    vmDataExperience.name &&
    vmDataExperience.products.length > 0

  const handleConfirm = () => {
    dispatch(resetApp())
    navigate(AppRoutes.intro())
  }

  useEffect(() => {
    if (!vmUrl && !isLoadingHash && isValidVmDataExperience) {
      const products = vmDataExperience.products
      const hasTransitions = products.some((p) => p.isTransition)

      let vmData = {
        ...vmDataExperience,
        transitionFeature: { enabled: hasTransitions },
      }

      dispatch(createHash(vmData))
    }
  }, [
    isLoadingHash,
    isValidVmDataExperience,
    dispatch,
    vmDataExperience,
    vmUrl,
  ])

  useEffect(() => {
    if (vmUrl && !shortUrl?.isLoading && !shortUrl?.key) {
      dispatch(createShortUrl(vmUrl))
    }
  }, [dispatch, vmUrl, shortUrl])

  return (
    <Box className={styles.container}>
      {qrCodeUrl && shortUrl && !shortUrl.isLoading && (
        <QRCodeGenerated
          isDigitalWindow={isDigitalWindow}
          tokenKey={tokenKey}
          qrCodeUrl={qrCodeUrl}
          vmUrl={vmUrl}
          handleConfirm={handleConfirm}
          title={
            expType === Experience.DigitalWindow
              ? 'Digital Window Generated!'
              : 'QR CODE GENERATED!'
          }
        />
      )}
    </Box>
  )
}
